import React, { useEffect, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { resetPaymentStatus } from '@kfc-global/react-shared/redux/Actions/PaymentsAction';

import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { UserOrderContext } from 'context/context';
import { paymentFailedAnalyticFn } from 'common/utilities/utils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

import {
  checkGiftCardPurchase,
  dispatchPostOrder,
  updateOrderAcceptedHandler,
  updatAddhopPurchaseDetails,
  updatGetGiftCardDetails,
  updateGiftCardPurchaseDetails,
} from '../utils/paymentFailedUtils';

const getPaymentFailedView = props => {
  return <LazyLoaderWrapper {...props} testId='PaymentFailedView' importPath='PAYMENT_FAILED_VIEW'></LazyLoaderWrapper>;
};

const PaymentFailed = props => {
  const [showFailedScreen, setShowFailedScreen] = useState(false);
  const { userOrderState } = useContext(UserOrderContext);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const createBalanceReducer = useSelector(state => state?.createBalanceReducer);
  const { tenantId, componentOptions } = tenantReducer;
  const dispatch = useDispatch();
  const { location } = props;
  const { isCardValidateFailedScreen = null } = location;
  const shouldNavigateToCheckout = componentOptions?.web?.checkout?.shouldNavigateToCheckout;

  // defines user's current state
  const userParamsFromStore = useSelector(data => {
    return data.appStateReducer.userStatus;
  });

  const { postOrderReducer, orderReducer } = useSelector(data => data);
  const { orderAccepted } = postOrderReducer;
  const isWicodeFinaliseFailed = orderAccepted?.isWicodeFinaliseFailed;

  useEffect(() => {
    checkGiftCardPurchase(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    showFailedScreen &&
      paymentFailedAnalyticFn(TRANSLATE_MAPPING_KEY?.THAT_AINT_RIGHT, TRANSLATE_MAPPING_KEY?.FAILED_MSG);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showFailedScreen]);

  useEffect(() => {
    dispatchPostOrder({ orderReducer, tenantId, dispatch, userOrderState, setShowFailedScreen, props });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId, orderReducer?.response]);

  useEffect(() => {
    updateOrderAcceptedHandler({ orderAccepted, dispatch, tenantId, userOrderState, setShowFailedScreen, props });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderAccepted]);

  useEffect(() => {
    updatAddhopPurchaseDetails({ postOrderReducer, setShowFailedScreen });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postOrderReducer?.addHopeOrderResponse]);

  useEffect(() => {
    updateGiftCardPurchaseDetails({ postOrderReducer, setShowFailedScreen });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postOrderReducer?.giftCardPurchaseResponse]);

  useEffect(() => {
    updatGetGiftCardDetails({ createBalanceReducer, setShowFailedScreen });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createBalanceReducer?.response]);

  useEffect(() => {
    dispatch(resetPaymentStatus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userParamsFromStore]);

  return (
    (showFailedScreen || isCardValidateFailedScreen) &&
    getPaymentFailedView({
      ...{ ...props, shouldNavigateToCheckout: shouldNavigateToCheckout },
      dispatch,
      orderAccepted,
      isCardValidateFailedScreen,
      isWicodeFinaliseFailed,
    })
  );
};

export default PaymentFailed;
